import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';

var Background = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: ", ";\n  width: 100vw;\n  height: 100vh;\n  opacity: ", ";\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: ", ";\n  width: 100vw;\n  height: 100vh;\n  opacity: ", ";\n"])), function (_a) {
    var zIndex = _a.zIndex;
    return "" + zIndex;
}, function (_a) {
    var visible = _a.visible;
    return (visible ? 1 : 0);
});
var DropdownWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 24rem;\n  max-height: calc(100vh - 32px);\n  padding: 0.8rem;\n  border-radius: 1.6rem;\n  background: ", ";\n  box-shadow: 0 2rem 4.8rem rgba(0, 0, 0, 0.2);\n  overflow-y: auto;\n  z-index: ", ";\n  opacity: ", ";\n"], ["\n  width: 24rem;\n  max-height: calc(100vh - 32px);\n  padding: 0.8rem;\n  border-radius: 1.6rem;\n  background: ", ";\n  box-shadow: 0 2rem 4.8rem rgba(0, 0, 0, 0.2);\n  overflow-y: auto;\n  z-index: ", ";\n  opacity: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.background.primary;
}, function (_a) {
    var zIndex = _a.zIndex;
    return "" + (zIndex + 1);
}, function (_a) {
    var visible = _a.visible;
    return (visible ? 1 : 0);
});
var templateObject_1, templateObject_2;

export { Background, DropdownWrapper };
